// These records remember credentials and navigation, never permissions.
const KEY = 'mb_remembered_sessions_v1';
let memory = { accounts: {}, last: null };
const metadata = token => {
  try { return JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))); }
  catch { return {}; }
};
const read = () => {
  try { return JSON.parse(localStorage.getItem(KEY)) || { accounts: {}, last: null }; }
  catch { return memory; }
};
const write = state => { memory = state; try { localStorage.setItem(KEY, JSON.stringify(state)); } catch {} };
const accountKey = (kind, token) => `${kind}:${metadata(token).user_id || 'primary'}`;
const remember = (kind, token) => {
  const state = read(), id = accountKey(kind, token);
  state.accounts[id] = { kind, token, userId: metadata(token).user_id || null, used: Date.now() };
  state.last = id;
  write(state);
};
const forget = (kind, token) => {
  const state = read(), id = accountKey(kind, token);
  delete state.accounts[id];
  if (state.last === id) state.last = null;
  write(state);
};
module.exports = { read, remember, forget, metadata, accountKey };
